import Link from "next/link"
import { ArrowRight } from "lucide-react"

import { cn } from "@/lib/utils"
import { Badge } from "@/components/ui/badge"

const segments = [
  { href: "/menuisier-ebeniste", label: "Menuisier Ébéniste" },
  { href: "/menuisier-agenceur", label: "Menuisier Agenceur" },
  { href: "/menuisier-standiste", label: "Menuisier Standiste" },
  { href: "/negociant", label: "Négociant" },
  { href: "/collectivites", label: "Collectivités" },
  { href: "/industriel", label: "Industriel" },
  { href: "/particuliers-ou-createurs", label: "Particulier ou Créateur" },
  { href: "/autres-metiers", label: "Autres Métiers" },
] as const

export function SegmentLinks() {
  return (
    <section className="section-normal px-4 md:px-6">
      <div className="mx-auto max-w-7xl">
        <Badge variant="secondary" className="mb-4">
          Nos clients
        </Badge>
        <h2 className="mb-8 text-2xl font-bold tracking-tight md:text-3xl">
          {"Qui fait appel à ce service ?"}
        </h2>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {segments.map((segment) => (
            <Link
              key={segment.href}
              href={segment.href}
              className={cn(
                "group flex items-center justify-between gap-3 rounded-xl px-5 py-4",
                "bg-foreground/[0.02] ring-1 ring-foreground/5",
                "dark:bg-background/[0.06] dark:ring-foreground/10",
                "transition-[ring-color,background-color] duration-200",
                "hover:ring-foreground/15 hover:bg-foreground/[0.04]"
              )}
            >
              <span className="text-sm font-medium">{segment.label}</span>
              <ArrowRight className="size-4 shrink-0 text-primary opacity-0 transition-[transform,opacity] duration-200 group-hover:translate-x-0.5 group-hover:opacity-100" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}
